module.exports = __webpack_public_path__ + "static/trc-front-card-bccf10101c15464b35752f3fafb3fad7.png";